import VoiceLanguage from './VoiceLanguage';
import CompositedAssetProvider from '../CompositeBundleAssetProvider';

export default class VoiceAssetProvider extends CompositedAssetProvider<VoiceLanguage> {}
